/*** Autogenerated. Use 'npm run generate-sources' to regenerate. ***/
import {RxJsonObject} from '../../../types/json/RxJsonObject';
import {JSONSchema4} from 'json-schema';
import {generateConverterToRx} from '../../../helpers/db/converters/generateConverterToRx';
import {generateArrayConverter} from '../../../helpers/db/converters/generateArrayConverter';
import {isDescribedByJsonSchema} from '../../../types/guards/isDescribedByJsonSchema';
import {isPartiallyDescribedByJsonSchema} from '../../../types/guards/isPartiallyDescribedByJsonSchema';
/**
 * Collection `properties` contains documents of `RxProperty` type.
 */
export interface RxProperty {
  /**
   * Primary key.
   */
  id: string;
  name?: string;
  description?: string;
  possible_values?: RxJsonObject;
  /**
   * Special property. Property indicates if given document is active and should be used in application. Document with this property set to `false` should be considered as non-existing.
   */
  active__document?: boolean;
}
export const RxPropertySchema: JSONSchema4 = {
    title: 'RxProperty',
    primaryKey: 'id',
    required: [
        'id',
    ],
    version: 0,
    type: 'object',
    properties: {
        id: {
            maxLength: 10000,
            type: 'string',
            description: 'Primary key.',
        },
        name: {
            type: 'string',
            description: '',
        },
        description: {
            type: 'string',
            default: '',
            description: '',
        },
        possible_values: {
            type: 'object',
            description: '',
        },
        active__document: {
            type: 'boolean',
            default: false,
            description: 'Special property. Property indicates if given document is active and should be used in application. Document with this property set to `false` should be considered as non-existing.',
        },
    },
    additionalProperties: false,
    description: 'Collection `properties` contains documents of `RxProperty` type.',
}
export const asRxProperty = generateConverterToRx<RxProperty>(RxPropertySchema, 'RxPropertySchema');
export const asRxPropertyArray = generateArrayConverter<RxProperty>(asRxProperty);
export function instanceOfRxProperty(o?: any): o is RxProperty { 
    return isDescribedByJsonSchema(o, RxPropertySchema, false, false); 
}
export function isRxProperty(o?: any): o is RxProperty { 
    return isDescribedByJsonSchema(o, RxPropertySchema, false, false); 
}
export function instanceOfPartialRxProperty(o?: any): o is Partial<RxProperty> { 
    return isPartiallyDescribedByJsonSchema(o, RxPropertySchema);
}
export function isPartialRxProperty(o?: any): o is Partial<RxProperty> { 
    return isPartiallyDescribedByJsonSchema(o, RxPropertySchema); 
}